import { classes } from "polytype";
import { AggregateMetaData, DataModel, ReferenceModel } from "../../base";
import assertObjectFound from "../../base/assertObjectFound";
import { config } from "../../config/config";
import { type AsyncResourceVariant, provideReact } from "../../react";
import type { WalletData } from "./types";

export class Wallet extends ReferenceModel {
  public static aggregateMetaData = new AggregateMetaData("wallet", "wallet");

  public static ofId(id: string) {
    return new Wallet(id);
  }

  public static find = provideReact(async (customerId: string) => {
    const data = await config.behaviors.wallet.find(customerId);
    if (data !== undefined) {
      return new WalletDetailed(data);
    }
  });

  public static get = provideReact(async (customerId: string) => {
    const wallet = await this.find(customerId);
    assertObjectFound(wallet, "wallet", customerId);
    return wallet;
  });

  public findDetailed = provideReact(
    () => Wallet.find(this.id),
    [this.id],
  ) as AsyncResourceVariant<() => Promise<WalletDetailed | undefined>>;

  public getDetailed = provideReact(
    () => Wallet.get(this.id),
    [this.id],
  ) as AsyncResourceVariant<() => Promise<WalletDetailed>>;

  public static async create(customerId: string) {
    await config.behaviors.wallet.create(customerId);
  }
}

class WalletCommon extends classes(DataModel<WalletData>, Wallet) {
  public readonly recommendationCode?: string;
  public readonly points: number;
  public constructor(data: WalletData) {
    super([data], [data.customerId]);
    this.recommendationCode = data.recommendationCode;
    this.points = data.points;
  }
}

export class WalletDetailed extends classes(
  WalletCommon,
  DataModel<WalletData>,
) {
  public constructor(data: WalletData) {
    super([data], [data]);
  }
}
